<template>
  <div style="margin-top:7vh">
    <div class="summaryNavbar">
      <div class="row">
        <div class="m-0 p-0 col-4">
          <span class="approverButton" style="padding-left:50px;">REQUEST NUMBER : {{answerCode}}</span>
        </div>
        <div class="col-4"></div>
        <div class="m-0 p-0 col-4 text-right">
          <button class="approverstatus" @click="openTrackingStatus(answerCode)" style="text-decoration: underline;">Approval Status</button>
          <b-modal
            v-model="openTrackingModal"
            ok-title="ok"
            title="TrackingStatus"
            @ok="closeTrackingModal($event)"
            @cancel="eventCancel($event)"
            scrollable
            :no-close-on-esc="true"
            :ok-only="true"
            size="xl"
          >
                                 
<table class="table-striped wf-history-table">
  <tbody>
    <tr v-for="(i,index) in traceData" :key="index">
      <td v-if="index==0 && originalArray.length > 0" class="trace-wrap">
        <div :title="originalArray[0].remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]">
          <span class="bold">By:</span> 
    {{originalArray[0].remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]}}</div>
   
    <div :title="Partner"><span class="bold">Role:</span> Partner</div>
    <div><span class="bold">Action:</span>
    <span class="text-green"> Submitted</span></div>
    <div :title="originalArray[0].remarks.split('-receiverdelimiter-')[0]"><span class="bold">Remarks:</span> {{originalArray[0].remarks.split('-receiverdelimiter-')[0]}}</div>
    <!--div>{{j.insertedOn.replace('T',' ').split('.')[0]}}</div-->
    
    <div :title="formatDateTime(originalArray[0].updatedOn,'T')"><span class="bold">updated:</span>
     {{formatDateTime(originalArray[0].updatedOn,'T')}}</div>
    <!--td>{{i.versionNumber}}</td>
    <td>{{i.companyCode}}</td>
    <td>{{i.documentWorkflowId}}</td--> 

        </td>
      <td  v-for="(j,k) in i" :key="k" class="trace-wrap" v-if="(j.actionStatus !== 4) && (j.isShow || j.actionStatus != 4 || ((j.frCode==0 || j.frCode ==101) && j.actionStatus==4))">
    <div v-if="!(index==0 && k==0)" :title="j.remarks.split('-receiverdelimiter-')[1].split('-senderdelimiter-')[0].split('~~~')[1].split('^^^')[0]">
      <span class="bold" v-if="false">Actor:</span> 
    <span v-if="false">{{j.remarks.split('-receiverdelimiter-')[1].split('-senderdelimiter-')[0].split('~~~')[1].split('^^^')[0]}}</span></div>
    <div  v-if="index==0 && k==0" :title="j.remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]">
      <span class="bold" v-if="false">Actor:</span>
     <span v-if="false">{{j.remarks.split('-senderdelimiter-')[1].split('~~~')[1].split('^^^')[0]}}</span></div>
    <div :title="getRoleName(j.frCode)"><span class="bold">Role:
      </span> {{getRoleName(j.frCode)}}</div>
    <div><span class="bold">Action:</span> 
    <span v-if="(j.frCode ==0 || getRoleName(j.frCode) == 'Partner')" class="text-green"> Submitted</span>
    <span v-if="!(j.frCode ==0 || getRoleName(j.frCode) == 'Partner')" :class="[j.actionStatus == 1 ? 'text-green':'', j.actionStatus == 2 ? 'text-orange':'',
    j.actionStatus == 3 ? 'text-red':'',j.actionStatus == 4 ? 'text-yellow':'']">
      {{j.actionStatus == 1 ? 'Approved' : ''}}   
      {{j.actionStatus == 2 ? 'SendBack' : ''}}  
      {{j.actionStatus == 3 ? 'Rejected' : ''}}
      {{j.actionStatus == 4 ? 'Requested' : ''}}
      {{j.actionStatus == 5 ? 'PartialApproved' : ''}}
      {{j.actionStatus == 6 ? 'AutoCancel' : ''}}
      {{j.actionStatus == 7 ? 'Created' : ''}}
      </span></div>
    <div :title="j.remarks.split('-receiverdelimiter-')[0]"><span class="bold">Remarks:</span> {{j.remarks.split('-receiverdelimiter-')[0]}}</div>
    <!--div>{{j.insertedOn.replace('T',' ').split('.')[0]}}</div-->
    <div :title="formatDateTime(j.updatedOn,'T')"><span class="bold">updated On:</span> {{formatDateTime(j.updatedOn,'T')}}</div>
    <!--td>{{i.versionNumber}}</td>
    <td>{{i.companyCode}}</td>
    <td>{{i.documentWorkflowId}}</td-->
      </td>
    </tr>
    </tbody>
</table>  
            <!-- <span > -->
            <div class="row m-0 p-3" v-for="(data,index) in trackingData" :key="index" style="min-width: 660px;">
              <div class="col-2 m-0 p-0 pl-3">
                <h4
                  v-if="index == 0"
                  id="tooltip-target-1"
                  class="role-Name mb-2 m-0 p-0"
                >{{roleName[0]}}</h4>
                <!-- <b-tooltip target="tooltip-target-1" triggers="hover">I am tooltip</b-tooltip> -->
                <span v-if="data.partner != null">
                  <span :class="dottedStatus(data.partner.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.partner.evaluatorsActionStatus}}</span>
                  <br />
                  <span class="popOverDate">{{getCreatedDate(data.partner.insertedOn)}}</span>
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <!-- <span v-if="trackingData.length-1 == index">pending</span>
                  <span v-else>-</span>-->
                  <span>-</span>
                </span>
              </div>
              <div class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[1]}}</h4>
                <span v-if="data.segregator != null">
                  <span :class="dottedStatus(data.segregator.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.segregator.evaluatorsActionStatus}}</span>
                  <br />
                  <!--span class="popOverStatusActionBy">{{data.segregator.actionBy}}</span>
                  <br /-->
                  <span class="popOverDate">{{getCreatedDate(data.segregator.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.segregator.remarks"
                  >Remarks</button>
                  <!-- <b-popover
                    :target="`remarkssegPopover${index}`"
                    :show.sync="pop1"
                    placement="bottomright"
                    ref="remarkssegPopover"
                    triggers="hover"
                  >
                    <div>
                      <p class="p-2">{{data.segregator.remarks}}</p>
                    </div>
                  </b-popover>-->
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <!-- <span v-if="trackingData.length-1 == index">pending</span> -->
                  <span>-</span>
                </span>
              </div>
              <div class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[2]}}</h4>
                <span v-if="data.buyer != null">
                  <span :class="dottedStatus(data.buyer.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.buyer.evaluatorsActionStatus}}</span>
                  <br />
                  <!--span class="popOverStatusActionBy">{{data.buyer.actionBy}}</span>
                  <br /-->
                  <span class="popOverDate">{{getCreatedDate(data.buyer.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.buyer.remarks"
                  >Remarks</button>
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <span :class="dottedStatus('Pending')"></span>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>

              <div v-if="roleName.length == 4" class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[3]}}</h4>
                <span class="popOverStatus ml-2">
                  <span :class="dottedStatus('Pending')"></span>
                  <span class="ml-2">Pending</span>
                </span>
              </div>

              <div v-if="roleName.length != 4" class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[3]}}</h4>
                <span v-if="data.technical != null">
                  <span :class="dottedStatus(data.technical.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.technical.evaluatorsActionStatus}}</span>
                  <br />
                  <!--span class="popOverStatusActionBy">{{data.technical.actionBy}}</span>
                  <br /-->
                  <span class="popOverDate">{{getCreatedDate(data.technical.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.technical.remarks"
                  >Remarks</button>
                  <!-- <b-popover
                    :target="`remarksTechPopover${index}`"
                    :show.sync="pop1"
                    placement="bottom"
                    ref="remarksTechPopover"
                    triggers="hover"
                  >
                    <div>
                      <p class="p-2">{{data.technical.remarks}}></p>
                    </div>
                  </b-popover>-->
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <span :class="dottedStatus('Pending')"></span>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
              <div v-if="roleName.length != 4" class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[4]}}</h4>
                <span v-if="data.commercial != null">
                  <span :class="dottedStatus(data.commercial.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.commercial.evaluatorsActionStatus}}</span>
                  <br />
                  <!--span class="popOverStatusActionBy">{{data.commercial.actionBy}}</span>
                  <br /-->
                  <span class="popOverDate">{{getCreatedDate(data.commercial.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.commercial.remarks"
                  >Remarks</button>
                  <!-- <b-popover
                    :target="`remarksCommPopover${index}`"
                    :show.sync="pop1"
                    placement="bottom"
                    ref="remarksCommPopover"
                    triggers="hover"
                  >
                    <div>
                      <p class="p-2">{{data.commercial.remarks}}></p>
                    </div>
                  </b-popover>-->
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <span :class="dottedStatus('Pending')"></span>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
              <div v-if="roleName.length != 4" class="col-2 m-0 p-0 pl-3">
                <h4 v-if="index == 0" class="role-Name m-0 mb-2 p-0">{{roleName[5]}}</h4>
                <span v-if="data.approver != null">
                  <span :class="dottedStatus(data.approver.evaluatorsActionStatus)"></span>
                  <span class="popOverStatus ml-2">{{data.approver.evaluatorsActionStatus}}</span>
                  <br />
                  <!--span class="popOverStatusActionBy">{{data.approver.actionBy}}</span>
                  <br /-->
                  <span class="popOverDate">{{getCreatedDate(data.approver.insertedOn)}}</span>
                  <br />
                  <button
                    class="popOverRemarks"
                    v-b-popover.hover.bottomright="data.approver.remarks"
                  >Remarks</button>
                  <!-- <b-popover
                    :target="`remarksAppPopover${index}`"
                    :show.sync="pop1"
                    ref="remarksAppPopover"
                    triggers="hover"
                  >
                    <div>
                      <p class="p-2">{{data.approver.remarks}}></p>
                    </div>
                  </b-popover>-->
                </span>
                <span class="popOverStatus ml-2" v-else>
                  <span v-if="trackingData.length-1 == index">
                    <p :class="dottedStatus('Pending')"></p>
                    <span class="ml-2">Pending</span>
                  </span>
                  <span v-else>-</span>
                </span>
              </div>
            </div>
          </b-modal>

          <button
            v-if="!submitPage"
            class="pr-4 submitButtonOverAll"
            type="button"
            @click="submit()"
          >Submit</button>
        </div>
      </div>
    </div>
    <div class="back-div p-3">
      <p class="m-0 p-0 back-div-text-style" @click="goToDashboardPage()">
        <img class="right-arrow left-arrow pt-1" src="@/assets/images/right-arrow.svg" />&nbsp;&nbsp;Back
      </p>
    </div>
    <w-loading-spinner :loadSpinner="loading" />

    <div class="row m-0 p-0" v-if="submitPage!=true">
      <div class="col-12 p-0 col-bg">
        <v-stepper alt-labels v-model="e1">
          <v-stepper-header>
            <template v-for="n in steps">
              <v-stepper-step
                :class="className[n-1]"
                :key="`${n}-step`"
                :step="steps"
                @click="stepper(n,'do')"
                complete
              >{{heading[n-1] }}</v-stepper-step>

              <v-divider v-if="n !== steps" :key="n"></v-divider>
            </template>
          </v-stepper-header>
        </v-stepper>
      </div>
    </div>
    <span
      v-if="onboardingPageResponse && submitPage!=true && this.selectedModuleName != 'General' && this.selectedModuleName != 'Financial'"
    >
      <div
        class="card groupcard card-layout mb-4 pt-4 pl-4"
        v-for="question in onboardingPageResponse"
        :key="question"
      >
        <h2 class="text-left headerText ml-2 mt-2 mb-2 m-0">{{question.groupName}}</h2>
        <hr class="m-0 mb-1" />
        <!-- font-weight-bold -->
        <div
          class="row"
          v-for="(response,index) in question.questionResponse"
          :key="index"
          :class="response.businessTypes"
        >
        <!--.filter(x=>x.savedAnswer && x.savedAnswer.length > 0)-->
          <div class="ml-3 mt-2 response-text">{{index + 1}}.</div>
          <div class="col-6 response-text text-left float-left m-0 mt-2">
            {{response.question}}
            <div v-for="(answer,index) in response.savedAnswer" :key="index">
              <div class="col-12 m-0 mt-2">{{answer.displayName}}</div>
            </div>
          </div>

          <div class="col-4" v-if="response.savedAnswer && response.savedAnswer[0]">
            <span v-for="(answer,index) in response.savedAnswer" :key="index">
              <div
                v-if="answer.controlType != 'U'"
                class="col-12 response-text text-left float-left mr-2 mt-2"
              >
                <span
                  v-if="answer.keyValue == 'Yes' || answer.keyValue == 'No'"
                >{{anwerKey(answer.keyValue)}}</span>
                <span v-else>
                  <span v-if="index == 0">
                    <br />
                  </span>
                  {{anwerKey(answer.keyValue,answer.controlType)}}
                </span>
              </div>
              <a
                v-if="answer.controlType == 'U'"
                class="text-left response-text float-left mr-2 mt-2"
                @click="showAttachFile(answer.keyValue)"
                href="#"
              >{{getAttachmentName(answer.keyValue)}}</a>
              <span v-if="values= answer.keyValue"></span>
            </span>
          </div>
        </div>
      </div>
    </span>
    <div v-if="selectedModuleName == 'General'">
      <c-genral :answerkey="answerCode" :branchLogIn="branchLogIn" :partnerdetail="dashboardData"/>
    </div>
    <div v-if="selectedModuleName == 'Financial'">
      <c-financial :answerkey="answerCode" :branchLogIn="branchLogIn"  :partnerdetail="dashboardData"/>
    </div>
    <w-attachment-popup
      :attachmentArray="attachmentArray"
      :attachmentName="attachmentName"
      @getAttachedDocument="getDocument($event)"
    />
  </div>
</template>

<script>
import RadioInput from "../widgets/RadioInput";
import FormInput from "../widgets/FormSelect";
import InputTextBox from "../widgets/InputTextWidget";
import table from "../widgets/table";
import TextArea from "../widgets/TextArea";
import { OnBoardingServices } from "../services/onBoardingService";
import { SummaryServices } from "../services/summaryService";
const SummaryService = new SummaryServices();
const OnBoardingService = new OnBoardingServices();
import { DashboardService } from "../services/DashboardService.js";
const DashboardServices = new DashboardService();
import AttachmentPopup from "../widgets/AttachmentPopup.vue";
import LoadingSpinner from "../widgets/LoadingSpinner";
import GenralSummary from "../components/summary/generalSummary";
import FinnancialSummary from "../components/summary/financialSummary";
import showSummaryDetails from "../widgets/summaryModel";
import moment from "moment";
const API_URL = process.env.VUE_APP_ROOT_API;

export default {
  components: {
    "w-multi-radio-button": RadioInput,
    "w-dropDowm-button": FormInput,
    "w-input-text": InputTextBox,
    "w-table": table,
    "w-text-area": TextArea,
    "w-summaryDetails": showSummaryDetails,
    // "c-genral": Genral,
    // "c-financial": Financial,
    "w-attachment-popup": AttachmentPopup,
    "w-loading-spinner": LoadingSpinner,
    "c-genral": GenralSummary,
    "c-financial": FinnancialSummary
  },
  watch: {
    selectedModuleName: function(newVal, oldVal) {
      // if (oldVal != null) {
      //   this.submittedModule = oldVal;
      // }
      // console.log("newName" + newVal);
    },

    selectedModule: function(newVal, oldVal) {
      // console.log("New Module" + newVal);
      this.attachmentArray = [
        {
          id: 1,
          documentName: "Name Goes Here"
        }
      ];
      // this.$element.removeData()

      if (
        this.selectedModuleName != "General" &&
        this.selectedModuleName != "Financial"
      ) {
        if (newVal != oldVal) {
          this.loading = true;
          OnBoardingService.getBoardingPreviewQuestions(
            this.selectedModule,
            this.answerCode
          ).then(resp => {
            console.log(resp);
            this.onboardingPageResponse = resp.response.groups;
            this.onboardingPageResponse.forEach(question => {
              this.additionalQuestions = question.questionResponse;

              this.additionalQuestions.forEach(answer => {
                this.questionCode = answer.questionCode;
                console.log(this.questionCode);
                this.showQuestion = answer.savedAnswer;

                // console.log("value", this.showQuestion);
                this.showQuestion.forEach((answerResponse, index) => {
                  this.answerResponse.push(answerResponse.keyValue);
                  // console.log("key", this.answerResponse);
                  // this.defaultSelectedArray.push(savedObject);
                });
              });
            });
            this.loading = false;
            this.summaryBussinessTypes = resp.response.partnerBusinessTypes;
            this.individualRating = null;
            // resp.response.partnerBusinessTypes.forEach(type => {});
            this.currentSelectedBusinessTab = 0;
            // this.selectedBusinessID = resp.response.partnerBusinessTypes[0].id;
          });
        }
      }
    }

    // currentTab: function(newVal, oldVal) {
    //   if (this.statusValue == "" && this.remarks == "") {
    //     this.currentTab = 0;
    //   }
    // }
  },
  computed: {
    className: () => {
      console.log("computed");
      return this.className;
    }
    // OverAlltabSelection: () => {
    //   return this.OverAlltabSelection;
    // }
  },
  created() {
    this.getAllInfo();
    this.getPartnerDetails();
  },

  data() {
    return {
      originalArray:[],
      frRolesList:[],
      traceData: [],
      docSearch: "",
      branchLogIn: false,
      attachmentName: "",
      dashboardData: "",
      answerResponse: [],
      questionCode: "",
      userName: null,
      userId: null,
      showModuleName: "",
      loading: false,
      approvedModal: false,
      rejectModel: false,
      sendBackModel: false,
      showModuleDetails: false,
      individualBussinessType: "",
      loadingModal: false,
      additionalQuestions: [],
      onboardingPageResponse: [],
      showQuestion: [],
      submitOverall: false,
      headingLength: null,
      heading: [],
      moduleCode: [],
      individualRating: null,
      e1: 1,
      overallTableColors: [],
      panel: 0,
      selectedModule: null,
      selectedModuleName: null,
      showSubmitButton: false,
      steps: null,
      partnerDetails: "",
      questions: null,
      indexSelected: null,
      showAlert: true,
      showClass: true,
      openTrackingModal: false,
      answerCode: null,
      trackingData: [],
      className: [
        "green-tick",
        "green-tick",
        "green-tick",
        "green-tick",
        "green-tick",
        "green-tick",
        "green-tick",
        "green-tick",
        "green-tick",
        "green-tick",
        "green-tick",
        "green-tick",
        "green-tick"
      ]
    };
  },
  methods: {
    formatDateTime(dt, splitter){ 
      console.log(dt)
      var dateArray = (dt.split(splitter)[0]).split('-')
      var timeArray = (dt.split(splitter)[1]).split(':')
      var date = dateArray[2]
      var month = dateArray[1]
      var year = dateArray[0] 
      var h = timeArray[0]
      var m = timeArray[1]
      return (date + '-' + month + '-' + year) + ' ' + ((h >= 12) ? h-12 : h) + ":" + m + " " + ((h >= 12) ? "PM" : "AM");
    },
    getPartnerDetails() {
      this.loading = true;
      this.secondaryBusinessesPopupItems = [];
      DashboardServices.getPartnerDetails().then(resp => {
        this.loading = false;
        if (resp) {
          this.dashboardData = resp.response;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
          this.onboardingStatus();
        }
      });
    },
    onboardingStatus() {
      this.loading = true;
      DashboardServices.onBoardingPreviewStatus(
        this.dashboardData.currentCategoryCode,
        this.dashboardData.currentCompanyCode
      ).then(resp => {
        this.loading = false;
        this.answerCode = resp.response.answerNumber;
        this.showSelected();
        this.getOnboardingHeading();
      });
    },
    anwerKey(answer, type) {
      if (answer == "") {
        answer = "__";
        return answer;
      }
      if (type == "DP") {
        return moment(answer).format("DD-MM-YYYY");
      } else {
        return answer;
      }
      // console.log("23123", answer);
    },
    dynamicTableView(answer) {
      return answer.keyValue;
    },
    getTdData(i, resp) {
      console.log(i);
      console.log(resp);
      console.log(resp.length / i, "5");
      if (i == 3) {
        let data = [];
        for (let i = 1; i < resp.length / i; i++) {}
      }
      if (i == 2) {
        for (let i = 1; i < resp.length / i; i++) {}
      }
      // if (i == 1) {
      //   for (let i = 1; i < resp.length / i; i++) {}
      // }
      return resp;
    },

    getAttachmentName(attachment) {
      if (attachment) {
        return attachment.split(/_(.+)/)[1];
      }
    },
    // showAttachFile(event) {
    //   window.location.href = API_URL + event;
    //   return false;
    // },

    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event).then(res => {
        this.loading = false;
      });
    },

    groupName(moduleCode) {
      let moduleName = this.heading[moduleCode - 1];
      return moduleName;
    },

    topFunction() {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },

    getAllInfo() {
      this.loading = true;
      OnBoardingService.getPartnerDetailsId().then(resp => {
        this.loading = false;
        // console.log(resp.response);
        // this.partnerDetails = resp.response;
        // this.userName = this.partnerDetails.loginName;
        this.$root.isInternational =
              resp.response.countryDetail.countryCode == 100 ? false : true;
        if (resp.response.partnerCategory == "B") {
          this.branchLogIn = true;
        } else {
          this.branchLogIn = false;
        }
        this.$forceUpdate();
      });
    },

    closeModule() {
      this.showModuleDetails = false;
    },

    viewGroupDetails(data, moduleName) {
      // console.log(data);
      this.getModuleName = moduleName;
      this.showModuleDetails = true;
      if (this.getModuleName === "General") {
        this.showModuleName = "General";
      } else if (this.getModuleName === "Financial") {
        this.showModuleName = "Financial";
      } else if (
        this.getModuleName != "General" &&
        this.getModuleName != "Financial"
      ) {
        SummaryService.getBoardingQuestions(data).then(resp => {
          // console.log(resp);
          this.onboardingPageResponse = resp.response.groups;
          this.summaryBussinessTypes = resp.response.partnerBusinessTypes;
        });
      }
    },

    getFileName(fileName) {
      let fileNameDisplay = fileName.split("_");
      var fileNameFinal = "";
      for (let i = 0; i < fileNameDisplay.length - 1; i++) {
        fileNameFinal += fileNameDisplay[i + 1];
      }
      fileNameFinal = fileNameFinal.split(".")[0];
      return fileNameFinal;
    },

    isSelectedBusinessType(businessList) {
      if (businessList.includes(this.selectedBusinessID)) {
        return " font-weight-bold";
      } else {
        return "font-weight-bold";
      }
    },

    showResponse(res) {
      if (this.res === "General") {
      }
      if (this.res === "Financial") {
      }
    },

    openTrackingStatus(answerNumber) {
      this.currentDocuNumberForAction = answerNumber
      this.loading = true;
      SummaryService.getWorkFlowHistory(answerNumber)
        .then(res => {
          this.loading = false;
            if (res.status == "SUCCESS") {
              this.originalArray = res.response.workflows
              this.frRolesList = res.response.frRolesList
          this.traceData=[]
          var n=[]
          //n.push(this.originalArray[0])
          for (var i = 0; i < this.originalArray.length; i++) {
            if (this.originalArray[i].actionStatus == 6) { 
              continue;
            } 
            if (this.originalArray.length-1 == i) {
              n.push(this.originalArray[i])
              this.traceData.push(n)
              n=[] 
            }
            else if (this.originalArray[i].actionStatus != 2) { 
              n.push(this.originalArray[i])
            } else if (this.originalArray[i].actionStatus == 2){
              n.push(this.originalArray[i])
              this.traceData.push(n)
              n=[]
            }
          }
          var lastArray = this.traceData[this.traceData.length-1];
          var allfour = lastArray.filter(x=>x.actionStatus==4)
          if(allfour.length == lastArray.length){
            for (var j=0; j<lastArray.length; j++){
              lastArray[j]["isShow"] = true;
            }
          }
          this.traceData[this.traceData.length-1] = lastArray
          //this.traceData[0][0]["frCode"] = 0
          console.log(this.traceData)
            } else {
              this.triggerModal = true;
              this.loading = false; 
              this.failureModal = false;              
              this.lastResponse = res.failureMessage; 
              this.alertModal = true;
            }
            this.openTrackingModal = true;
            })
        .catch(err => {
          this.loading = false;
              this.triggerModal = true;
              this.loading = false;
              this.lastResponse = err.failureMessage ? err.failureMessage : "Something went wrong. Try again later.";
              this.alertModal = true;
        });
      /*SummaryService.getTrackingData(answerNumber)
        .then(res => {
          this.loading = false;
          this.trackingData = res.response.status;
          this.roleName = res.response.evaluatorsName;
      this.openTrackingModal = true;
        })
        .catch(err => {
          this.loading = false;
        });*/
    },
    getRoleName(frCode) {
      if (frCode == 0)
      {
        return 'Partner'
      }
      return this.frRolesList.filter(x=>x.frCode == frCode).length > 0 ? 
      (this.frRolesList.filter(x=>x.frCode == frCode)[0]).longDesc : 'Not available'
    },
    getCreatedDate(date) {
      return moment(date).format("DD-MMM-YYYY hh:mm A");
    },
    dottedStatus(status) {
      if (status == "Approved") {
        return "dottedGreen";
      }
      if (status == "Sendback") {
        return "dottedSendback";
      }
      if (status == "Rejected") {
        return "dottedRejected";
      }
      if (status == "Pending") {
        return "dottedPending";
      }
    },

    getOnboardingHeading() {
      this.heading = [];
      this.moduleCode = [];
      OnBoardingService.checkOverAllStatus(
        this.dashboardData.currentCategoryCode
      ).then(res => {
        if (res) {
          this.steps = res.response.length;
          this.totalHeading = res.response;
          this.totalHeading.forEach(element => {
            this.heading.push(element.moduleName);
            this.moduleCode.push(element.moduleCode);
          });
        }
      });
    },

    // checkOverallBussiness() {
    //   OnBoardingService.checkOverAllStatus().then(res => {
    //     if (res) {
    //       res.response.forEach((data, index) => {
    //         if (data.savedResponse == data.totalResponse) {
    //           this.className[index] = "green-tick";
    //         }
    //         for (let i = 0; i < this.className.length; i++) {
    //           if (this.className[i].includes(" activeClass")) {
    //             // console.log(this.className);
    //             this.className[i] = this.className[i].split(" activeClass")[0];
    //           }
    //         }
    //         this.className.splice(
    //           this.indexSelected - 1,
    //           1,
    //           this.className[this.indexSelected - 1] + " activeClass"
    //         );
    //       });
    //     }
    //   });
    // },
    stepper(index) {
      this.selectedModule = this.moduleCode[index - 1];
      this.selectedModuleName = this.heading[index - 1];
      for (let i = 0; i < this.className.length; i++) {
        if (this.className[i].includes(" activeClass")) {
          // console.log(this.className);
          this.className[i] = this.className[i].split(" activeClass")[0];
        }
      }
      this.className.splice(
        index - 1,
        1,
        this.className[index - 1] + " activeClass"
      );
      // console.log(this.className);
      this.indexSelected = index;
    },
    goToDashboardPage() {
      this.$router.push("/dashboard");
    },

    showSelected() {
      this.className[0] += " activeClass";
      this.selectedModule = 1;
      this.submitPage = false;
      this.selectedModuleName = "General";
      this.indexSelected = 1;
    }
  }
};
</script>

<style>
.green-tick .v-stepper__step__step .v-icon {
  color: white !important;
  background-color: #28b915 !important;
  border-radius: 20px;
  cursor: pointer;
}
.orange-tick .v-stepper__step__step .v-icon {
  color: #efa500 !important;
  background-color: white !important;
  border-radius: 20px;
  border: dashed 1.2px #efa500;
  background-color: #ffffff;
  cursor: pointer;
}
.dotted .v-stepper__step__step .v-icon {
  color: #00000000 !important;
  background-color: #7e7e7e !important;
  border-radius: 20px;
  height: 10px;
  width: 10px;
  cursor: pointer;
}
.activeClass > .v-stepper__label {
  border-bottom: 4px solid #002d72 !important;
  color: #002d72 !important;
  padding-bottom: 10px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: 600;
}
.v-stepper__label {
  color: rgba(0, 0, 0, 0.87);
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 17px;
  color: #4d4c4c;
}
</style>
<style scoped>
label {
  margin: 0;
}
.left-arrow {
  transform: rotate(180deg);
}
.back-div {
  background-color: white;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.55;
  letter-spacing: normal;
  text-align: left;
  color: #002d72;
}
.back-div-text {
  width: 90%;
  margin: 0 auto;
}
.back-div-text-style {
  cursor: pointer;
  width: fit-content;
}
.v-stepper__label {
  cursor: pointer;
}

.col-bg {
  background-color: white !important;
}
/* .green-tick .v-stepper__step__step .v-icon {
  color: white !important;
  background-color: #28b915 !important;
  border-radius: 20px;
  cursor: pointer;
}
.orange-tick .v-stepper__step__step .v-icon {
  color: #efa500 !important;
  background-color: white !important;
  border-radius: 20px;
  border: dashed 1.2px #efa500;
  background-color: #ffffff;
  cursor: pointer;
}
.dotted .v-stepper__step__step .v-icon {
  color: #00000000 !important;
  background-color: #7e7e7e !important;
  border-radius: 20px;
  height: 10px;
  width: 10px;
  cursor: pointer;
} */
/* .activeClass > .v-stepper--alt-labels .v-stepper__header {
  height: 100% !important;
} */
/* .activeClass > .v-stepper__step {
  padding-bottom: 0 !important;
} */
/* .activeClass > .v-stepper__label {
  border-bottom: 4px solid #002d72 !important;
  color: #002d72;
  padding-bottom: 10px !important;
  padding-left: 10px !important;
  padding-right: 10px !important;
  cursor: pointer;
} */
.percentage {
  font-size: 30px;
  font-weight: 600;
  color: #002d72;
}
.percentageText {
  font-size: 20px;
  line-height: 1.55;
  color: #002d72;
}
.card-img {
  height: 90px;
  margin: auto;
}
.groupcard {
  width: 90% !important;
  height: auto !important;
  padding: 40px;
  margin: 0 auto;
}
.cardText {
  margin-left: 10%;
  margin-right: 10%;
}
.cardDetails {
  font-size: 20px;
  font-weight: 600;
  letter-spacing: 0.2px;
  color: #272727;
}
.selectedbox {
  border-radius: 6px;
  box-shadow: 0 2px 8px 0 rgba(0, 45, 114, 0.3);
  border: solid 3px #002d72;
}
.heading-main {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px;
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.72;
  letter-spacing: 0.18px;
  text-align: left;
  color: #272727;
}
.heading-side {
  margin-left: 10px;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 3.5;
  letter-spacing: 0.14px;
  text-align: left;
  color: #212121;
}
.card-layout {
  margin-top: 20px;
  padding: 10px;
  width: 90% !important;
  height: auto;
}
.sub-headings {
  margin-left: 10px;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  /* font-size: 16px; */
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  color: #363636;
}
.fields {
  position: absolute;
  left: 40%;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  /* font-size: 16px; */
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  text-align: left;
  color: #6f6f6f;
}
.hr-style {
  border: solid 1px #bababa;
  background-color: #ffffff;
  width: 50%;
}
.satisfaction-colors-red {
  border: none;
  border-radius: 50px;
  padding: 8px;
  background-color: #df000033;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #e33232 !important;
  /* color: #4d4c4c;  --  INACTIVE */
}
.satisfaction-colors-green {
  border: none;
  border-radius: 50px;
  padding: 8px;
  background-color: #28b91533;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #28b915 !important;
  /* color: #4d4c4c;  --  INACTIVE */
}
.satisfaction-inactive {
  border: none;
  border-radius: 50px;
  padding: 8px;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: normal;
  text-align: left;
  color: #4d4c4c;
}
.satisfaction-colors-green:active {
  /* text-decoration: underline; */
  border: none;
  border-radius: 50px;
  padding: 8px;
  background-color: #28b91533;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
  text-align: left;
  color: #28b915;
  /* color: #4d4c4c;  --  INACTIVE */
}
.save-and-continue {
  width: fit-content;
  padding: 10px;
  border: solid 1px #002d72;
  background-color: #ffffff;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.64px;
  text-align: left;
  color: #002d72;
  float: right;
  margin-right: 5%;
  margin-top: 1%;
  margin-bottom: 5%;
  padding-right: 40px !important;
  padding-left: 40px !important;
}
.save-and-continue:disabled {
  color: grey;
  border: 1px solid grey;
  cursor: not-allowed !important;
}
.save-and-continue-approve {
  width: fit-content;
  padding: 5px;
  border: solid 1px white;
  background-color: #0a9930;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: 0.64px;
  padding-right: 40px !important;
  padding-left: 40px !important;
  text-align: left;
  color: #ffffff;
  padding: 10px;
  float: right;
  margin-right: 5%;
  margin-top: 1%;
  margin-bottom: 5%;
}
.save-and-continue-approve:disabled {
  cursor: not-allowed !important;
}
.reject-and-continue-approve:disabled {
  cursor: not-allowed !important;
}

.reject-and-continue-approve {
  width: fit-content;
  padding: 5px;
  border: solid 1px white;
  background-color: #e33232;

  font-family: "Source Sans Pro", sans-serif;
  font-size: 16px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.64px;
  padding-right: 40px !important;
  padding-left: 40px !important;
  text-align: left;
  color: #ffffff;
  padding: 10px;
  float: right;
  margin-right: 5%;
  margin-top: 1%;
  margin-bottom: 5%;
}

.attachment {
  padding: 5px;
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.5;
  letter-spacing: 0.14px;
  text-align: left;
  color: #636567;
  border: solid 1px #d6d6d6;
  background-color: #f4f4f4;
  position: absolute;
  left: 5%;
  top: 10%;
}
.border-right-color {
  border-right: 1px solid #bababa;
}
.buyer-feedback {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 2.45;
  letter-spacing: 0.2px;
  text-align: left;
  color: #002d72;
}
.headerText {
  /* font-family: "Titillium Web", sans-serif; */
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.18px;
  text-align: left;
  color: #272727;
}
.green-text {
  color: #00b998;
  font-weight: 600;
  width: 10%;
}
.red-text {
  color: #e74c3c;
  font-weight: 600;
  width: 10%;
}
.tables {
  color: #212529;
  max-width: 100%;
  padding: 10%;
  background-color: #ffffff;
  text-align: left;
  margin-right: 5%;
  margin-left: 5% !important;
}
.table thead th {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0.18px;
  color: #8e8e8e;
  text-align: left;
}
.tableHeading {
  font-size: 18px !important;
  font-weight: 600 !important;
  color: #002d72 !important;
  padding: 1% !important;
}
.model > #module-details___BV_modal_outer_ > .modal.show .modal-dialog {
  max-width: 90% !important;
}
.remarksTable {
  width: 50% !important;
}
/* .ratingTable {
  width: 5%;
} */
.separator {
  background-color: #f8f8f8;
}
.financialHeading {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.18px;
  /* margin-bottom: 3%; */
  color: #272727;
}
.response-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
}
.separator > th {
  border: none !important;
}
.remarksvalue {
  cursor: pointer;
}
.scrollable {
  width: auto;
  max-height: 10vh;
  margin: 0;
  padding: 0;
  overflow: auto;
}
.maxRemarks {
  width: 5%;
  cursor: pointer;
}
.maxBussinessType {
  width: 10%;
}
.nav-tabs .nav-link.active {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.16px;
  /* width: 200px; */
}

.nav-tabs .nav-link.inactive {
  color: #6f6f6f;
}
.nav-tabs .nav-link {
  color: #6f6f6f !important;
  text-decoration: none;
  background-color: transparent;
}
.low-Rating {
  color: red;
  font-size: 18px;
  font-weight: bold;
}
.medium-Rating {
  color: aquamarine;
  font-size: 18px;
  font-weight: bold;
}
.high-Rating {
  color: green;
  font-size: 18px;
  font-weight: bold;
}
.selectedBussinessTypeFont {
  color: #00000088;
}
h3 {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 20px;
}
.ratingScore {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 18px;
  letter-spacing: 0.18px;
  color: #272727;
}
.v-progress-circular__info {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 17px;
  font-weight: 600;
  /* color: black; */
}
.cardBorder {
  padding: 7px;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  border: solid 1px #d6d6d6;
  background-color: #1a72ab !important;
  margin: initial;
  border-radius: 25px;
}
.bussinessTypeText {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: 600;
  padding: 7px; background: #efefef;
    border-radius: 100px;
}
.financialsubHeading {
  font-family: "Source Sans Pro", sans-serif;
  font-weight: 600;
  font-size: 15px;
  letter-spacing: 0.18px;
  margin-bottom: 3%;
  color: #272727;
}
.tableBorder {
  border-right: 1px solid #bababa;
}

.bankScroll {
  max-height: 8vh;
  margin: 0;
  padding: 0;
  overflow-y: scroll;
  overflow-x: hidden;
}
.summaryNavbar {
  background-color: #14436a;
}
.approverButton {
  font-size: 16px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  outline: none !important;
  padding: 3%;
  float: left;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.approverstatus {
  font-size: 16px;
  font-weight: 600;
  color: white;
  cursor: pointer;
  font-family: "Source Sans Pro", sans-serif;
  outline: none !important;
  padding: 3%;
  float: left;
  margin-left: 40%;
  -webkit-box-shadow: none !important;
  box-shadow: none !important;
}
.role-Name {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 10% !important;
}
.popOverRemarks {
  cursor: pointer;
  float: left;
  font-size: 12px;
  color: #747474;
  text-decoration: underline;
  outline: none !important;
}
.popOverDate {
  float: left;
  font-size: 12px;
  color: #747474;
}
.role-Name {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  font-weight: bold;
  text-decoration: underline;
  margin-bottom: 10% !important;
  text-align: left;
}
.dottedGreen {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #28b915;
  float: left;
  margin-top: 3%;
}
.dottedPending {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #f4cf08;
  float: left;
  margin-top: 7%;
}
.dottedRejected {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #e61313;
  float: left;
  margin-top: 3%;
}
.dottedSendback {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: #002d72;
  float: left;
  margin-top: 3%;
}
.popOverStatus {
  font-size: 12px;
  font-weight: bold;
  float: left;
}
.popOverStatusActionBy {
  font-size: 12px;
  float: left;
}

.wf-history-table{
  width: 100%;
}
.wf-history-table td{
  padding:10px;
}
.text-green{
  color:green;
  font-weight: bold;
}
.text-red{
  color:red;
  font-weight: bold;
}
.text-yellow{
  color:#dec300;
  font-weight: bold;
}
.text-orange{
  color:orange;
  font-weight: bold;
}
.bold{
  font-weight: bold;
}
.trace-wrap{
  height: 20px;
    overflow: hidden;
    white-space: nowrap;
    max-width: 200px;
    text-overflow: ellipsis;
}
.trace-wrap div{
  overflow: hidden;
    text-overflow: ellipsis;
}
</style>